import { TotalData } from './index.type';
export const defaultTotalData: TotalData = 
    {
        max_profit_take: '',
        sharpe_ratio: '',
        return_rate_last_month: '',
        return_rate_last_3months: '',
        return_rate_last_6months: '',
        anualized_return_rate: '',
        vs_csi300: '',
        monthly_avg_trades: '',
        annualized_turnover_rate: '',
        trading_activity_rank: '',
        market_analysis: '',
        suggestion: '',
        holding_product_review: '',
        cash_before: '',
        stable_before: '',
        aggressive_before: '',
        holding_fund_count: '',
        largest_holding_fund: '',
        holding_industry_count: '',
        largest_industry_ratio: '',
        top5_industry_ratio_details: '',
        top5_holding_ratio: '',
        top10_holding_ratio: '',
        largest_holding_style: '',
        excess_return_last_6months: '',
        style_dimension: '',
        investment_behavior_analysis: '',
        total_return_rate: '',
        excess_return: '',
        trading_win_rate: '',
        profit_loss_ratio: '',
        industry_allocation_profit: '',
        stock_holding_profit: '',
        buying_preference_ratio: '',
        selling_preference_ratio: '',
        // max_profit_take: '',
        max_stop_loss: '',
        avg_profit_take: '',
        avg_stop_loss: '',
        annual_turnover_rate: '',
        // monthly_avg_trades: '',
        avg_holding_period: '',
        return_60d_after_buy: '',
        return_5d_after_sell: '',
        cash_after: '',
        stable_after: '',
        aggressive_after: '',
        advantage1_title: '',
        advantage1_desc: '',
        advantage2_title: '',
        advantage2_desc: '',
        advantage3_title: '',
        advantage3_desc: '',
        return_res: '',
        pullback: '',
        recommend_cash_name1: '',
        recommend_cash_return1: '',
        recommend_cash_percent1: '',
        recommend_cash_name2: '',
        recommend_cash_return2: '',
        recommend_cash_percent2: '',
        recommend_stable_name1: '',
        recommend_stable_return1: '',
        recommend_stable_percent1: '',
        recommend_stable_name2: '',
        recommend_stable_return2: '',
        recommend_stable_percent2: '',
        recommend_aggressive_name1: '',
        recommend_aggressive_return1: '',
        recommend_aggressive_percent1: '',
        recommend_aggressive_name2: '',
        recommend_aggressive_return2: '',
        recommend_aggressive_percent2: '',
      }
 ;